var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSlide32Filled = function SvgIconSlide32Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.23 6.77H9.77a1.2 1.2 0 0 0-1.2 1.2v8.06a1.2 1.2 0 0 0 1.2 1.2h4.46a1.2 1.2 0 0 0 1.2-1.2V7.97a1.2 1.2 0 0 0-1.2-1.2Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.77 7.62a.35.35 0 0 0-.35.35v8.06c0 .193.156.35.35.35h4.46a.35.35 0 0 0 .35-.35V7.97a.35.35 0 0 0-.35-.35H9.77Zm-2.05.35a2.05 2.05 0 0 1 2.05-2.05h4.46a2.05 2.05 0 0 1 2.05 2.05v8.06a2.05 2.05 0 0 1-2.05 2.05H9.77a2.05 2.05 0 0 1-2.05-2.05V7.97ZM17.814 17.52V6.475h1.7V17.52h-1.7ZM4.48 17.52V6.475h1.7V17.52h-1.7Z",
    fill: "current"
  })));
};
export default SvgIconSlide32Filled;